/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// document.addEventListener("DOMContentLoaded", function () {
//   var ANIM_DURATION = 250;
//   var scrollY = 0;

//   function lockScroll() {
//     scrollY = window.scrollY || window.pageYOffset;
//     document.body.style.position = "fixed";
//     document.body.style.top = "-" + scrollY + "px";
//     document.body.style.left = "0";
//     document.body.style.right = "0";
//     document.body.style.width = "100%";
//   }

//   function unlockScroll() {
//     var y = scrollY;
//     document.body.style.position = "";
//     document.body.style.top = "";
//     document.body.style.left = "";
//     document.body.style.right = "";
//     document.body.style.width = "";

//     window.scrollTo(0, y);
//   }

//   function setupModal(modalId, triggerSelector, closeSelector) {
//     var modal = document.getElementById(modalId);
//     var trigger = document.querySelector(triggerSelector);

//     if (!modal || !trigger) return;

//     if (modal.parentNode !== document.body) {
//       document.body.appendChild(modal);
//     }

//     var closeButtons = modal.querySelectorAll(
//       closeSelector || "[data-modal-close]",
//     );

//     function openModal() {
//       modal.hidden = false;
//       requestAnimationFrame(function () {
//         modal.classList.add("is-open");
//       });
//       lockScroll();
//     }

//     function closeModal() {
//       modal.classList.remove("is-open");
//       setTimeout(function () {
//         if (!modal.classList.contains("is-open")) {
//           modal.hidden = true;
//           unlockScroll();
//         }
//       }, ANIM_DURATION);
//     }

//     trigger.addEventListener("click", openModal);
//     closeButtons.forEach(function (btn) {
//       btn.addEventListener("click", closeModal);
//     });

//     document.addEventListener("keydown", function (e) {
//       if (e.key === "Escape" && !modal.hidden) {
//         closeModal();
//       }
//     });
//   }

//   setupModal(
//     "CharacterModal",
//     "[data-character-modal-open]",
//     "[data-character-modal-close]",
//   );
//   setupModal(
//     "ModelModal",
//     "[data-model-modal-open]",
//     "[data-model-modal-close]",
//   );
// });

// シリーズコレクション

// loadinganimation();
scrollanimation();
//parallax();
// function loadinganimation() {
//   const wrappers = document.querySelectorAll(".series_wrap");

//   wrappers.forEach((wrapper) => {
//     function hiding() {
//       wrapper.classList.add("hiding");
//     }
//     function showing() {
//       wrapper.classList.add("showing");
//     }
//     function end_loader() {
//       wrapper.classList.add("loaded");
//     }

//     window.addEventListener("load", function () {
//       showing();
//       setTimeout(() => {
//         hiding();
//       }, 1000);
//       setTimeout(() => {
//         end_loader();
//       }, 3000);
//     });
//   });
// }

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".series_wrap");
  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("showing");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      threshold: 0.2,
    },
  );
  sections.forEach((section) => observer.observe(section));
});

function scrollanimation() {
  const objects = document.querySelectorAll(".fade_in");
  const cb = function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("fade_done");
        observer.unobserve(entry.target);
      }
    });
  };
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.3,
  };
  const io = new IntersectionObserver(cb, options);
  objects.forEach((object) => {
    io.observe(object);
  });
}
function parallax() {
  const targetClass = ".js_parallax_elm_box";
  const childClass = ".js_parallax_elm";
  const targets = Array.prototype.slice.call(
    document.querySelectorAll(targetClass),
    0,
  );
  if (targets.length === 0) {
    return false;
  }
  let winH = window.innerHeight;
  parallaxFunk("init");
  window.addEventListener("resize", function () {
    winH = window.innerHeight;
    requestAnimationFrame(parallaxFunk);
  });
  window.addEventListener("scroll", function () {
    requestAnimationFrame(parallaxFunk);
  });
  function parallaxFunk(i) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollBottom = scrollTop + winH;
    targets.forEach(function (target) {
      const targetPosi = target.getBoundingClientRect().top + scrollTop;
      const targetHeight = target.clientHeight;
      const targetShowPosi = targetPosi - winH;
      const targetEndPosi = targetPosi + targetHeight;
      if (i == "init") {
        const centerPosi = targetEndPosi - targetShowPosi;
        target.setAttribute("position", centerPosi);
        const centerScr = scrollTop - winH / 2;
        if (centerPosi < centerScr) {
          console.log("down");
        } else {
          console.log("up");
        }
      }
      if (scrollTop > targetShowPosi && scrollTop < targetEndPosi) {
        const child = target.querySelectorAll(childClass);
        if (!child) {
          return false;
        }
        child.forEach(function (c) {
          const cl = Array.prototype.slice.call(c.classList);
          if (cl.indexOf("para_start") == -1) {
            c.classList.add("para_start");
            c.setAttribute("basis", scrollTop);
            c.setAttribute("pos", c.getBoundingClientRect().top);
          }
          const basePosi = c.getAttribute("pos");
          const basis = c.getAttribute("basis");
          const speed = c.getAttribute("speed");
          const childHeight = c.clientHeight;
          const setVal = ((basis - scrollTop) * speed).toFixed(1);
          c.style.transform = "translate3d(0," + -setVal + "px,0)";
        });
      }
    });
  }
}
const swiperSlides = document.getElementsByClassName("swiper-slide");
const breakPoint = 900;
let mySwiper;
let mySwiperBool;
window.addEventListener(
  "load",
  () => {
    if (breakPoint < window.innerWidth) {
      mySwiperBool = false;
    } else {
      createSwiper();
      mySwiperBool = true;
    }
  },
  false,
);
window.addEventListener(
  "resize",
  () => {
    if (breakPoint < window.innerWidth && mySwiperBool) {
      mySwiper.destroy(false, true);
      mySwiperBool = false;
    } else if (breakPoint >= window.innerWidth && !mySwiperBool) {
      createSwiper();
      mySwiperBool = true;
    }
  },
  false,
);
const createSwiper = () => {
  mySwiper = new Swiper(".image_swiper", {
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    slidesPerView: "auto",
    loopedSlides: 4,
    spaceBetween: 10,
    speed: 5000,
    centeredSlides: false,
    freeMode: {
      enabled: true,
      momentum: false,
    },
    grabCursor: true,
    on: {
      touchEnd: (swiper) => {
        swiper.slideTo(swiper.activeIndex + 1);
      },
    },
  });
};
